var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewxl = function SvgNewxl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#325A6D",
    fillRule: "evenodd",
    d: "M12.242 4.242a.5.5 0 0 1 0 .707L8.706 8.485l3.536 3.535a.5.5 0 1 1-.707.707L7.999 9.192l-3.535 3.535a.5.5 0 1 1-.707-.707l3.535-3.535-3.535-3.536a.5.5 0 0 1 .707-.707l3.535 3.536 3.536-3.536a.5.5 0 0 1 .707 0",
    clipRule: "evenodd"
  })));
};
export default SvgNewxl;